// extracted by mini-css-extract-plugin
export default {"wrapper":"Op-z","response":"Pp-z","error":"Qp-z","disabled":"Rp-z","buttons":"Sp-z","feedbackQuestionSection":"Tp-z","yesNoWrapper":"Up-z"};